module.exports = __webpack_public_path__ + "img/our-works-1.png";